import React, { useState } from 'react'
import { toast } from 'react-toastify'
import { useParams } from '../Providers/ParamsProvider'

const useGoogleApis = () => {
    const { geolocationApiKey } = useParams()
    const [postalCodeFromLocation, setPostalCodeFromLocation] = useState(null)

    const handleFetchPostalCode = async () => {
        setPostalCodeFromLocation(null)
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(async (position) => {
                const { latitude, longitude } = position.coords
                try {
                    const response = await fetch(
                        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${geolocationApiKey}`
                    )
                    const data = await response.json()
                    if (data.results && data.results.length > 0) {
                        // Szukamy komponentu adresu zawierającego typ "postal_code"
                        let addressComponents = null;
                        let postalComponent = null;
                        for (let i = 0; i < data.results.length; i++) {
                            addressComponents = data.results[i].address_components
                            postalComponent = addressComponents.find(comp =>
                                comp.types.includes('postal_code'))
                            if (postalComponent.long_name.length === 6) {
                                break;
                            }
                        }

                        if (postalComponent) {
                            setPostalCodeFromLocation(postalComponent.long_name)
                            return (postalComponent.long_name)
                        } else {
                            toast.error(`Nie znaleziono kodu pocztowego`)
                            return false
                        }
                    } else {
                        toast.error(`Brak wyników geokodowania`)
                        return false
                    }
                } catch (e) {
                    toast.error(`Błąd podczas pobierania danych`)
                    console.log(e)
                    return false
                }
            }, (geolocationError) => {
                toast.error(`Nie udało się pobrać lokalizacji`)
                return false
            })
        } else {
            toast.error(`Geolokalizacja nie jest wspierana przez Twoją przeglądarkę`)
            return false
        }
    }

    return { handleFetchPostalCode, postalCodeFromLocation }
}

export default useGoogleApis      